'use client';
import PropTypes from 'prop-types';
import { DeletionModal } from '@components/DeletionModal/DeletionModal';
import { EditModal } from '@components/EditModal/EditModal';
import { deleteAppliance } from '@utils/graphql/creators/appliances';
import { EditButton, DeleteButton } from '@pages/split/TableActions';
import { ApplianceForm } from '@components/FormComponents/ApplianceForm/ApplianceForm';
import { removeDependentStreamsWarning } from '@pages/split/utils/Constants';
import { MenuItem, Divider } from '@mui/material';
import '../split/TableActions.css';
import { handleTableActionsKeyDown } from '../split/utils/helpers';
import { useRef } from 'react';

export const ApplianceActions = ({ rowInfo, id }) => {
  const editButtonRef = useRef(null);
  const deleteButtonRef = useRef(null);
  const buttonArray = [editButtonRef, deleteButtonRef];

  return [
    <MenuItem
      key='edit-appliance-button'
      onKeyDown={(event) => {
        handleTableActionsKeyDown(event, buttonArray, 0);
      }}
    >
      <EditModal
        data={rowInfo}
        FormComponent={ApplianceForm}
        fieldName='appliance'
        trigger={({ handleOpen }) =>
          <EditButton
            ref={editButtonRef}
            data={rowInfo}
            handleOpen={handleOpen}
            focusIdOnEscape={id}
          />
        }
      />
    </MenuItem>,
    <Divider key='divider'/>,
    <MenuItem
      key='delete-appliance-button'
      onKeyDown={(event) => {
        handleTableActionsKeyDown(event, buttonArray, 1);
      }}>
      <DeletionModal
        customMessage={removeDependentStreamsWarning}
        headerIcon='fa-solid fa-gear'
        data={rowInfo}
        handleDelete={deleteAppliance}
        fieldName='appliance'
        trigger={({ handleOpen }) =>
          <DeleteButton
            ref={deleteButtonRef}
            data={rowInfo}
            handleOpen={handleOpen}
            focusIdOnEscape={id}
          />
        }
      />
    </MenuItem>,
  ];
};

ApplianceActions.propTypes = {
  rowInfo: PropTypes.object,
  id: PropTypes.string,
};